import { render, staticRenderFns } from "./AudioParticulars.vue?vue&type=template&id=ff2f436c&scoped=true"
import script from "./AudioParticulars.vue?vue&type=script&lang=js"
export * from "./AudioParticulars.vue?vue&type=script&lang=js"
import style0 from "./AudioParticulars.vue?vue&type=style&index=0&id=ff2f436c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f436c",
  null
  
)

export default component.exports